import axios from "axios";

var baseURL = "https://loc.linkberatung.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.linkberatung.de"
) {
  baseURL = "https://loc.linkberatung.de";
}

if (window.location.hostname == "www.linkberatung.de") {
  baseURL = "https://www.linkberatung.de";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
